import { render } from "./WorkflowStatsFile.vue?vue&type=template&id=0cc114fc&scoped=true"
import script from "./WorkflowStatsFile.vue?vue&type=script&lang=ts"
export * from "./WorkflowStatsFile.vue?vue&type=script&lang=ts"

import "./WorkflowStatsFile.vue?vue&type=style&index=0&id=0cc114fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0cc114fc"

export default script